// hooks/useSWRMutation.ts
import useSWRMutation from "swr/mutation";
import { AxiosInstance, AxiosRequestConfig } from "axios";
import axios from "axios";
type CRUDType = "post" | "put" | "delete" | "patch" | "get";

export function useSWRMutationHook<T>(
  url: string,
  axiosInstance: AxiosInstance,
  crudType: CRUDType,
  options?: AxiosRequestConfig
) {
  // Define the mutation function
  const mutationFn = async (url: string, data: any) => {
    const config: AxiosRequestConfig = {
      ...options,
      headers: {
        ...options?.headers,
      },
    };

    const payload = data.arg;
    const param = payload?.param;
    if (param) {
      delete payload.param;
    }
    // Handle FormData specially - don't destructure it, pass it directly to axios
    if (payload instanceof FormData) {
      switch (crudType) {
        case "post":
          return axiosInstance.post(url, payload, config).then((res) => res.data);
        case "put":
          return axiosInstance.put(url, payload, config).then((res) => res.data);
        case "delete":
          return axiosInstance.delete(url, config).then((res) => res.data);
        case "patch":
          return axiosInstance.patch(url, payload, config).then((res) => res.data);
        case "get":
          return axiosInstance.get(url, config).then((res) => res.data);
        default:
          throw new Error(`Invalid CRUD type for mutation: ${crudType}`);
      }
    }

    // For non-FormData, destructure normally
    switch (crudType) {
      case "post":
        return axiosInstance
          .post(param ? `${url}/${param}` : url, payload, config)
          .then((res) => res.data);
      case "put":
        return axiosInstance
          .put(param ? `${url}/${param}` : url, payload, config)
          .then((res) => res.data);
      case "delete":
        return axiosInstance
          .delete(param ? `${url}/${param}` : url, config)
          .then((res) => res.data);
      case "patch":
        return axiosInstance
          .patch(param ? `${url}/${param}` : url, payload, config)
          .then((res) => res.data);
      case "get":
        return axiosInstance
          .get(param ? `${url}/${param}` : url, config)
          .then((res) => res.data);
      default:
        throw new Error(`Invalid CRUD type for mutation: ${crudType}`);
    }
  };

  // Use SWRMutation for handling mutations
  const { trigger, data, error, isMutating } = useSWRMutation<T>(
    url,
    mutationFn
  );

  return {
    trigger: (data?: any) => trigger(data),
    data,
    error,

    isMutating,
  };
}
